import * as types from "./mutation-types";

export default {
  [types.GET_ALL_STORES](state, payload) {
    state.allStores = payload;
  },
  [types.GET_MASTER_STORE](state) {
    const masterStore = state.allStores.filter((e) => {
      return e.master == true;
    });
    localStorage.setItem(
      "masterStore",
      JSON.stringify({ masterStore: masterStore })
    );
    state.masterStore = masterStore[0];
  },
  [types.GET_SUB_STORES](state) {
    const subStores = state.allStores.filter((e) => {
      return e.master == false;
    });
    localStorage.setItem("subStores", JSON.stringify({ subStores: subStores }));
    state.subStores = subStores;
  },
  [types.GET_SELECTED_STORE](state, payload) {
 
    if (payload == false) {
      const masterStore = state.allStores.filter((e) => {
        return e.master == true;
      });
      state.selectedStore = masterStore[0];
    }
    if (payload) {
      const selectedStore = state.allStores.filter((e) => {
        return e.id == payload;
      });
      state.selectedStore = selectedStore[0];
    }
  },
  [types.SET_VALUE_IN_STORE](state, payload) {
    console.log("event", payload);
    state.selectedStore = payload;
    console.log("updStore", state.selectedStore);
  },
  [types.SAVE_STORE](state,payload) {
    console.log('updating store state', payload)
    state.selectedStore = payload;
    if(payload.master == true){
      state.masterStore = payload
    }
    else{
          const subStoresIndex = state.allStores.findIndex(s => s.id == payload.id)
          state.allStores[subStoresIndex] = payload
    }
    const allStoresIndex = state.allStores.findIndex(s => s.id == payload.id)
    state.allStores[allStoresIndex] = payload
    
  },

};
